<template>
    <div>
        <div class="flex flex-wrap mb-6">
            <div class="w-full lg:w-2/3">
                <annotation-filter
                    :annotations="annotations"
                    :self_id="self_id"
                    :enable_private_annotations="enable_private_annotations"
                    @filtered="filtered"
                />
            </div>

            <div class="w-full lg:w-1/3 flex flex-col items-end justify-between">
                <a class="btn text-xs self-stretch text-center ml-2" href="/mychapters?with-annotations=false">Review Unpolished Chapters</a>
                <div class="w-full flex items-end justify-between">
                    <div class="pl-2 hidden lg:block">
                        <div class="text-gray-800 uppercase text-xxs font-bold leading-none tracking-wide">
                            Sort
                        </div>

                        <i aria-hidden="true" class="material-icons text-3xl font-bold block -mb-1" style="margin-left: -2px;">sort</i>
                    </div>

                    <div class="flex">
                        <annotation-sort
                            label="Report Chapter"
                            value="section"
                            :selected="sort"
                            @click="sortBy"
                        />

                        <annotation-sort
                            label="Newest"
                            value="created"
                            :selected="sort"
                            @click="sortBy"
                        />

                        <annotation-sort
                            label="Most Recent Comment"
                            value="comment"
                            :selected="sort"
                            @click="sortBy"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-for="annotation in sorted_annotations"
            class="flex rounded-md shadow-lg mb-6"
        >
            <annotation-list-item
                class="rounded-l-md w-2/3"
                :key="'annotation-' + annotation.id"
                :annotation="annotation"
                :self_id="self_id"
                :hover="false"
                @updateComments="updateComments"
                @deleteAnnotation="deleteAnnotation"
            />

            <annotation-list-item-details
                class="rounded-r-md w-1/3"
                :key="'detail-' + annotation.id"
                :annotation="annotation"
            />
        </div>
    </div>
</template>

<script>
import AnnotationListItem from './annotation-list-item.vue';
import AnnotationListItemDetails from './annotation-list-item-details.vue';
import AnnotationSort from './annotation-sort.vue';
import AnnotationFilter from './annotation-filter.vue';

export default {
    components: {
        AnnotationListItem,
        AnnotationListItemDetails,
        AnnotationSort,
        AnnotationFilter,
    },

    props: {
        annotations: {},
        self_id: {},
        enable_private_annotations: { type: Boolean, default: false },
    },

    data() {
        return {
            sort: 'section',
            filtered_annotations: this.annotations,
        }
    },

    computed: {
        sorted_annotations() {
            switch (this.sort) {
                case 'created':
                    return _.orderBy(this.filtered_annotations, 'created_at', 'desc')
                    break;
                case 'comment':
                    return _.orderBy(this.filtered_annotations, 'updated_at', 'desc')
                    break;
                default:
                    return _.orderBy(this.filtered_annotations, 'report_section_name', 'asc')
            }
        },
    },

    methods: {
        sortBy(order) {
            this.sort = order;
        },
        filtered(annotations) {
            this.filtered_annotations = annotations;
        },

        deleteAnnotation(id) {
            let index = this.annotations.findIndex(annotation => annotation.id == id);

            if (index > -1) {
                this.annotations.splice(index, 1);
            }
        },
        updateComments({ id, comments }) {
            this.annotations.find(annotation => {
                return annotation.id === id;
            }).comments = comments;
        },
    },
}
</script>
